import React from 'react';
import BrandLogo from './BrandLogo';
import LoginForm from './LoginForm';

const LoginMobile = (props) => (
  <div className="login-mobile-page">
    <div className="login-split-blobs" aria-hidden>
      <span className="login-blob login-blob--1" />
      <span className="login-blob login-blob--2" />
    </div>
    <div className="login-mobile-shell">
      <div className="login-mobile-brand">
        <BrandLogo variant="mark" className="login-brand-mark" />
        <span className="login-split-brand-name">TYCHI</span>
      </div>

      <h1 className="login-split-hello">Login</h1>
      <p className="login-split-welcome">Welcome to log in to your background management system.</p>

      <LoginForm
        {...props}
        emailId="login-email-mobile"
        passwordId="login-password-mobile"
      />
    </div>
  </div>
);

export default LoginMobile;
